import React from "react";
import Marquee from "react-marquee-slider";

import {
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image10,
  Image7,
} from "../assets";

const images1 = [Image1, Image7, Image3, Image4];
const images2 = [Image5, Image6, Image10, Image2];

function Gallery(props) {
  return (
    <div className="h-auto mt-16 md:mt-20 lg:mt-32">
      <div className="mb-5 sm:mb-10">
        <Marquee velocity={25}>
          {images1.map((id) => (
            <div className="px-2 sm:px-4" key={id}>
              <img
                className="object-cover rounded-3xl h-44 md:h-56 lg:h-64 w-72 sm:w-auto"
                src={id}
                alt="serving"
              />
            </div>
          ))}
        </Marquee>
      </div>
      <div>
        <Marquee velocity={25} direction="ltr">
          {images2.map((id) => (
            <div className="px-2 sm:px-4" key={id}>
              <img
                className="object-cover rounded-3xl h-44 md:h-56 lg:h-64 w-72 sm:w-auto"
                src={id}
                alt="serving"
              />
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
}

export default Gallery;
